import { createReducer } from '@src/redux/helpers/createReducer';
import { UPDATE_TERMS, VALIDATE_TERMS } from './constants';

const initialState = {
  trackingNumber: {},
};

export const termsOfUseReducer = createReducer(initialState, {
  [`${UPDATE_TERMS}_STARTED`]: (state, action) => {
    return {
      trackingNumber: { ...state },
    };
  },
  [`${UPDATE_TERMS}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      trackingNumber: { ...state, ...action.payload },
    };
  },
  [`${VALIDATE_TERMS}_STARTED`]: (state, action) => {
    return {
      trackingNumber: {},
    };
  },

  [`${VALIDATE_TERMS}_SUCCESS`]: (state, action) => {
    const val = {
      ...state,
      trackingNumber: { ...state, ...action.payload },
    };
    return val;
  },
});
